module.exports = __webpack_public_path__ + "media/operational-planning_de_ipad_air.40089a34.mp4";